import styled, { css } from '@xstyled/styled-components';
import { CarouselTinderVariants } from '../CarouselTinderStore';

export const Wrapper = styled.divBox<{ variant: CarouselTinderVariants }>`
  display: grid;
  width: 100%;
  min-height: 100%;
  overflow: hidden;

  padding-top: 150px !important;
  @media (max-width: 520px) {
    padding-top: 180px !important;
  }

  ${p => {
    switch (p.variant) {
      case 'standard':
        return css`
          grid-template-columns: 1fr;
          grid-template-rows: 1fr;
          grid-template-areas: 'item';
        `;
    }
  }}
`;
